import Table from 'components/CWSTable/Table';
import React, { ReactNode } from 'react';

interface Props {
	columns: Array<any>;
	data: Array<any>;
	pageSize: number;
	count: number;
	onPageChange: (page, pageSize) => void;
	onSort: (sortBy, sort) => void;
	sortBy: string;
	sort: string;
	page: number;
	isSearch: boolean;
	preHeader: ReactNode;
}

const ApprovalListTable: React.FC<Props> = ({
	columns,
	data,
	pageSize,
	count,
	onPageChange,
	onSort,
	sortBy,
	sort,
	page,
	isSearch,
	preHeader,
}) => {
	return (
		<Table
			columns={columns}
			data={data}
			count={count}
			pageSize={pageSize}
			onPageChange={onPageChange}
			onSort={onSort}
			sort={sort}
			sortBy={sortBy}
			page={page}
			isSearch={isSearch}
			preHeader={preHeader}
			modalIsOpen={false}
		/>
	);
};

export default ApprovalListTable;
